import { LmsAdapter } from './types';

/**
 * Fallback adapter used when no LMS host is detected. Every call is a no-op
 * so that consumer code never needs to special-case "no LMS available".
 */
export const noopAdapter: LmsAdapter = {
  name: 'noop',
  isAvailable: false,
  setProgressMeasure: () => undefined,
  setScore: () => undefined,
  setReachedEnd: () => undefined,
  setPassed: () => undefined,
  concedeControl: () => undefined,
  recordMultipleChoiceInteraction: () => undefined,
  recordTrueFalseInteraction: () => undefined,
  recordSequencingInteraction: () => undefined,
  recordFillInInteraction: () => undefined,
  getLearnerLanguagePreference: () => Promise.resolve('')
};
